import { VMInstanceType } from '../types/vm.type';

export const vmInstanceTypes: VMInstanceType[] = [
  { id: 't3.nano', name: 'ky.edge', kubiyName: 'ky.edge', awsType: 't3.nano', cpu: '2 vCPUs', ram: '0.5 GB', price: '$0.0052/hr' },
  { id: 't3.micro', name: 'ky.core', kubiyName: 'ky.core', awsType: 't3.micro', cpu: '2 vCPUs', ram: '1 GB', price: '$0.0104/hr' },
  { id: 't3.small', name: 'ky.pulse', kubiyName: 'ky.pulse', awsType: 't3.small', cpu: '2 vCPUs', ram: '2 GB', price: '$0.0208/hr' },
  { id: 't3.medium', name: 'ky.forge', kubiyName: 'ky.forge', awsType: 't3.medium', cpu: '2 vCPUs', ram: '4 GB', price: '$0.0416/hr' },
  { id: 't3.large', name: 'ky.titan', kubiyName: 'ky.titan', awsType: 't3.large', cpu: '2 vCPUs', ram: '8 GB', price: '$0.0832/hr' },
  { id: 't3.xlarge', name: 'ky.titan', kubiyName: 'ky.titan', awsType: 't3.xlarge', cpu: '4 vCPUs', ram: '16 GB', price: '$0.1664/hr' },
];

export const osTypeFilters = [
  { id: 'linux', name: '', icon: '/images/linux.png', isImage: true },
  { id: 'windows', name: '', icon: '/images/windows.png', isImage: true },
  { id: 'macos', name: 'macOS', icon: '🍎', isImage: false },
  { id: 'unix', name: 'Unix', icon: '💻', isImage: false },
];
